import React, { useState } from "react";
import moment from "moment";
import DateTimePickerModal from "react-native-modal-datetime-picker";
import { StyleSheet, TouchableOpacity } from "react-native";
import i18n from "@microdoing/shared/i18n";
import { MainText } from "app/components/common";
import theme from "app/Theme/Theme";

const styles = StyleSheet.create({
  main: {
    backgroundColor: theme.colors["brand.100"],
    borderRadius: 6,
    paddingVertical: 8,
    paddingHorizontal: 15,
  },
});

interface ReminderTimeProps {
  hour: number;
  minute: number;
}
interface Props {
  reminderTime: {
    hour: number;
    minute: number;
  };
  onChangeReminderTime: (data: ReminderTimeProps) => void;
}

const HourBoxSelector = ({
  reminderTime,
  onChangeReminderTime = () => null,
}: Props) => {
  const { hour, minute } = reminderTime;
  const [isDatePickerVisible, setDatePickerVisibility] = useState(false);

  const showDatePicker = () => {
    setDatePickerVisibility(true);
  };

  const hideDatePicker = () => {
    setDatePickerVisibility(false);
  };

  const handleConfirm = date => {
    hideDatePicker();
    const newHour = moment(date).hour();
    const newMinute = moment(date).minute();
    onChangeReminderTime({ hour: newHour, minute: newMinute });
  };

  const timeMoment = moment().hour(hour).minute(minute);

  return (
    <TouchableOpacity style={styles.main} onPress={showDatePicker}>
      <MainText variant="l4-medium" color="brand.500">
        {timeMoment.format("HH:mm")}
      </MainText>
      <DateTimePickerModal
        isVisible={isDatePickerVisible}
        mode="time"
        locale="en_GB"
        date={timeMoment.toDate()}
        onConfirm={handleConfirm}
        onCancel={hideDatePicker}
        confirmTextIOS={i18n.t("confirm")}
        cancelTextIOS={i18n.t("cancel")}
      />
    </TouchableOpacity>
  );
};

export default HourBoxSelector;
